import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { SubDealersQueryKeys } from "./subDealersQueryKeys";
import { getSubDealers, GetSubDealersQueryParams } from "@/api/subDealers";

export const useSubDealers = (options: GetSubDealersQueryParams) => {
  return useQuery({
    queryKey: [SubDealersQueryKeys.All, options],
    placeholderData: keepPreviousData,
    enabled: options ? options.enabled : true,
    queryFn: ({ signal }) => {
      const params = {
        subDealerIds: options?.subDealerIds,
        dealerUsernames: options?.dealerUsernames,
      };
      return getSubDealers({ signal, params });
    },
  });
};
